<body>
    <div>
        <div *ngIf="dataLoaded">
            <table class="table2">
                <thead>
                    <th class="centro-align">
                        <!-- <i-feather name="plus-circle" (click)="addViagem('')"></i-feather> -->
                    </th>
                    <th class="corlinha">
                        Container LC Pneus
                    </th>
                </thead>
            </table>

            <div class="table2">
                <table>
                    <thead>
                        <tr>
                            <th class="auto-width">
                                Transportador
                            </th>
                            <th class="auto-width">
                                Placa
                            </th>
                            <th class="auto-width">
                                Localização Atual do Veículo
                            </th>
                            <th class="auto-width">
                                Posição atual do Veículo
                            </th>
                            <th class="auto-width">
                                Rastreio
                            </th>
                            <th class="auto-width">
                                Container
                            </th>
                            <th class="auto-width">
                                Fatura
                            </th>
                            <th class="auto-width">
                                Peça
                            </th>
                            <th class="auto-width">
                                Descrição
                            </th>
                            <th class="auto-width">
                                Qtd Peças
                            </th>
                            <th class="auto-width">
                                Qtd MU
                            </th>
                            <th>
                                Terminal Atual
                            </th>
                            <th>
                                Destino
                            </th>
                            <th>
                                Distância Percurso
                            </th>
                            <th>
                                Destino Após
                            </th>                          
                            <th>
                                Item Crítico
                            </th>
                            <th>
                                Janela
                            </th>
                            <th>
                                Data Falta
                            </th>
                            <th>
                                Container danificado
                            </th>
                            <th>
                                Editar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of items; let i = index">
                            <tr>
                                <td>{{ item.transportador }}</td>
                                <td>{{ item.Plate}}</td>
                                <td>{{ item.localizacao}}</td>
                                <td>{{ item.position}}</td>
                                <td *ngIf="item['Conexao'] === true" ><i-feather name="zap"
                                    class="blinking-icon"></i-feather></td>
                                <td *ngIf="item['Conexao'] !== true" ><i-feather name="zap-off"
                                    class="vermelho-icon"></i-feather></td>
                                <td>{{ item.idContainer}}</td>
                                <td>{{ item.fatura}}</td>
                                <td>{{ item.part}}</td>
                                <td>{{ item.description}}</td>
                                <td>{{ item.quantidadeParts}}</td>
                                <td>{{ item.quantidadeMU}}</td>
                                <td>{{ item.terminalAtual}}</td>
                                <td>{{ item.destino}}</td>
                                <td>{{ item['Total Distance'] | number:'1.2-2'}}</td>
                                <td>{{ item.destinoApos}}</td>
                                <td>{{ item.itemCritico}}</td>
                                <td>{{ item.Janela | date : 'dd/MM/yyyy HH:mm' : '+00:00' }}</td>
                                <td>{{ item.dataFalta | date : 'dd/MM/yyyy HH:mm' }}</td>
                                <td *ngIf="item.danificado">
                                    <input type="checkbox" [checked]="item.danificado">
                                  </td>
                                  <td *ngIf="!item.danificado">
                                    <input type="checkbox" [disabled]="true">
                                  </td>
                                <td class="same-line-container">
                                    <i-feather name="edit" (click)="editDialog(item)"
                                        class="button-spacing"></i-feather>
                                    <i-feather name="check-square" (click)="completaViagem(item)"
                                        class="button-spacing"></i-feather>
                                    <i-feather name="delete" (click)="deleteItem(item.ID)"
                                        class="button-spacing"></i-feather>
                                </td>
                            </tr>
                            <div *ngIf="informationMode[i]">
                                <table class="centered-table">
                                    <tr>
                                        <td><label>Última Atualização</label></td>
                                        <td><label>Último Sinal do Veículo</label></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input type="text" [(ngModel)]="item['data_atualizacao']">
                                        </td>
                                        <td>
                                            <input type="text" [(ngModel)]="item['DataBordo']">
                                        </td>
                                    </tr>

                                </table>
                                <table class="centered-table2">
                                    <tr>
                                        <button (click)="informationMode[i] = false">Ok</button>
                                    </tr>
                                </table>
                            </div>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</body>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
    <h3 class="modal-title">Ajuste de Programação</h3>
    <div class="modal-body">
        <form class="inputs">
            <table class="table2000 edicao">
                <tr>
                    <td class="tdLabel">
                        <label class="modal-label">Transportadora</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="transportador" [(ngModel)]="item.transportador" class="modal-input1">
                    </td>
                    <td class="tdLabel">
                        <label class="modal-label">Placa</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="Plate" [(ngModel)]="item.Plate" class="modal-input1">
                    </td>
                    <td class="tdLabel">
                        <label class="modal-label">Container</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="idContainer" [(ngModel)]="item.idContainer" class="modal-input1">
                    </td>
                </tr>
                <tr>
                    <td class="tdLabel">
                        <label class="modal-label">Quantidade MU</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="quantidadeMU" [(ngModel)]="item.quantidadeMU" class="modal-input1">
                    </td>
                    <td class="tdLabel">
                        <label class="modal-label">Destino Após</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="destinoApos" [(ngModel)]="item.destinoApos" class="modal-input1">
                    </td>
                    <td class="tdLabel">
                        <label class="modal-label">Destino</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="destino" [(ngModel)]="item.destino" class="modal-input1">
                    </td>
                </tr>
                <tr>
                    <td class="tdLabel">
                        <label class="modal-label" >Terminal Atual</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" id="terminalAtual" [(ngModel)]="item.terminalAtual" name="terminalAtual"
                            class="button-spacing">
                    </td>
                    <td class="tdLabel">
                        <label class="modal-label">Danificado</label>
                    </td>
                    <td class="checkBox">
                        <input  type="checkbox" name="danificado" [(ngModel)]="item.danificado" class="modal-input1">
                    </td>
               
                    <td class="tdLabel">
                        <label class="modal-label">Item Crítico</label>
                    </td>
                    <td class="tdInput">
                        <input type="string" name="itemCritico" [(ngModel)]="item.itemCritico" class="modal-input1">
                    </td>
                    <td class="tdLabel">
                        <label class="modal-label">Janela</label>
                    </td>
                    <td class="tdInput">
                        <input type="date" name="dataJanela" [(ngModel)]="item.dataJanela" class="modal-input1">
                        <input type="time" name="horaJanela" [(ngModel)]="item.horaJanela" class="modal-input1">
                    </td>
                </tr>
                <tr>
                    <td class="tdBotao">
                        <button class="botao" type="button" (click)="salvar(item)">Save</button>
                    </td>
                    <td class="tdBotao">
                        <button class="botao" type="button" (click)="cancel()">Cancel</button>
                    </td>
                </tr>
            </table>
        </form>
    </div>
</clr-modal>

<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>
